import type { FieldSpec, NestedFieldSpec } from '@wix/wix-data-schema-types'
import { FieldType } from '@wix/wix-data-schema-types'

const { object } = FieldType

export const isOfObjectTypeWithFields = (field: FieldSpec | NestedFieldSpec) =>
  field.type === object && !!field.fields
